import React from 'react';
import { Alert, Stack, Typography } from '@mui/material';

const money = (value) => new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(Number(value || 0));
const paid = (status) => ['paid_gateway', 'paid_manual'].includes(status);

export default function MatricPaymentSummary({ enrollment, financials }) {
  if (!financials) return null;
  if (financials.needsReview) return <Alert severity="warning">Payment reconciliation required: {financials.message}</Alert>;
  return <Stack spacing={0.5} aria-label="Registration and tuition breakdown">
    <Typography>Registration: {money(financials.registrationAmount)} - {financials.registrationPaid ? 'Paid' : financials.registrationAmount ? 'Unpaid' : 'Not applicable'}</Typography>
    <Typography>Tuition total: {money(financials.tuitionTotal)}</Typography>
    <Typography>Tuition received: {money(financials.tuitionReceived)}</Typography>
    <Typography>Total received: {money(financials.amountPaid)}</Typography>
    <Typography fontWeight={700}>Remaining balance: {money(financials.balanceDue)}</Typography>
    <Typography>Lesson access: {enrollment.accessStatus === 'active' ? 'Active' : financials.balanceDue === 0 || paid(enrollment.paymentStatus) ? 'Payment received; awaiting class confirmation' : financials.registrationPaid ? 'Registration paid; awaiting tuition payment' : 'Awaiting payment'}</Typography>
  </Stack>;
}
